import { getProductBase } from '@libs/api-proxy-client';
import { logSentryError } from '@libs/common-next';
import { logger } from '@libs/core';

import { SentryErrors } from '@/shared/sentry';

import { mapProductData } from './mapper';

export const fetchProductBase = async (id: string, onlineAt?: number) => {
    try {
        const { data, errors } = await getProductBase(id, onlineAt);
        return { data: mapProductData({ data }), errors };
    } catch (error) {
        const statusCode = (error as { statusCode?: number })?.statusCode;

        if (statusCode === 404) {
            logger.warn('[FETCH PRODUCT BASE][Warn]: %o', error);
            return null;
        }

        logger.error('[FETCH PRODUCT BASE][Error]: %o', error);
        logSentryError(error, SentryErrors.ProductBaseAPI.FetchProductBaseFailed);
        return null;
    }
};
